import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="10 0 44 64" {...props}>
    <path d="M20.5 0L11 9.5L33.5 32L11 54.5L20.5 64L52.5 32L20.5 0Z" />
  </IconBox>
);
